// extracted by mini-css-extract-plugin
module.exports = {"Offer__preview":"Offer__preview__cMm","Offer__title":"Offer__title_Cmtb","Offer__periode":"Offer__periode_3Sna","Offer__content":"Offer__content_3mwx"};